"use client"

import { Trans } from "@lingui/react/macro"
import { cn } from "@rarible_int/anaconda_ui_components"
import Link from "next/link"
import { COLLECTION_LISTING_PATH } from "../collection-listing/collection-listing-form"

export function ListCollectionLink() {
  return (
    <Link
      href={`/all${COLLECTION_LISTING_PATH}`}
      className={cn(
        "px-3 py-2 font-medium text-[#FAFF00] text-lg [text-shadow:0_0_10px_rgba(161,249,0,0.60)]",
      )}
    >
      <Trans>List collection</Trans>
    </Link>
  )
}
